import React, { Component } from "react"
import { Card, CardBody, Col, Label, Input, FormGroup, CardTitle } from "reactstrap"
import {
    createNotificationHelpers,
    updateStoreHeadlessStore,
} from "../utils";

export default class HeadlessStore extends Component {
    constructor(props) {
        super(props)
        this.state = {
            is_headless_store: props.is_headless_store || false,
            store_domain: props.store_domain || ''
        }

        // Initialize notification helpers
        const notifications = createNotificationHelpers();
        this.notify_info = notifications.notify_info;
        this.notify_error = notifications.notify_error;
        this.notify_success = notifications.notify_success;
    }

    // Update state when props change
    componentDidUpdate(prevProps) {
        if (prevProps.is_headless_store !== this.props.is_headless_store) {
            this.setState({ is_headless_store: this.props.is_headless_store });
        }
    }

    /**
     * Handles Headless Store checkbox change
     */
    handleChangeCheckbox = async () => {
        const answer = window.confirm("Are you sure you want to change?");
        if (!answer) {
            return;
        }

        const storeData = {
            store_domain: this.props.store_domain,
            is_headless_store: !this.state.is_headless_store
        };

        const success = await updateStoreHeadlessStore(
            storeData,
            this.notify_success,
            this.notify_error
        );

        if (success) {
            this.setState({ is_headless_store: !this.state.is_headless_store });
        }
    }
    render() {
        return (
            <React.Fragment>
                <Col xl={this.props.colSize}>
                    <Card className="shadow-sm">
                        <CardBody className="py-4">
                            <CardTitle tag="h6" className="mb-3 text-muted">
                                Headless Store
                            </CardTitle>
                            <p className="text-muted small mb-3">
                                Enable if this store uses a headless (API-only) front-end.
                            </p>
                            <FormGroup className="form-check form-switch mb-0 d-flex align-items-center justify-content-between py-2 px-3 rounded bg-light">
                                <Label
                                    htmlFor="headless-store-switch"
                                    className="form-check-label mb-0 fw-normal"
                                >
                                    Is Headless Store
                                </Label>
                                <Input
                                    type="checkbox"
                                    name="is_headless_store"
                                    className="form-check-input"
                                    id="headless-store-switch"
                                    onChange={this.handleChangeCheckbox}
                                    checked={this.state.is_headless_store}
                                />
                            </FormGroup>
                        </CardBody>
                    </Card>
                </Col>
            </React.Fragment>
        )
    }
}